import { render, staticRenderFns } from "./btnDownload.vue?vue&type=template&id=f10bf096&scoped=true&"
import script from "./btnDownload.vue?vue&type=script&lang=js&"
export * from "./btnDownload.vue?vue&type=script&lang=js&"
import style0 from "./btnDownload.vue?vue&type=style&index=0&id=f10bf096&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10bf096",
  null
  
)

export default component.exports